import React, { Component, PropTypes } from 'react'
import { get } from 'lodash/object'
import { connect } from 'react-redux'
import { setContractFilter, fetchContractData } from 'state/actions'
import { EasinsureContractsFilter } from './EasinsureContractsFilter'
import { EasinsureContractsList } from './EasinsureContractsList'
import ContractDetails from 'elements/ClientContractDetails'
import styles from './EasinsureContracts.scss'

@connect(state => ({
	isPhone: state.responsive.isPhone,
	isTablet: state.responsive.isTablet,
	contracts: state.client.contracts,
	opened: state.app.opened,
	filter: state.client.filter,
}))
export class EasinsureContracts extends Component {
	constructor(props) {
		super(props)
		this.handleFilterClicked = this.handleFilterClicked.bind(this)
	}
	componentDidMount() { this.update() }
	componentDidUpdate() { this.update() }

	handleFilterClicked(filter) {
		const { dispatch } = this.props
		dispatch(setContractFilter(filter))
	}

	returnOpenedContract(openedId) {
		const { contracts } = this.props
		const allContracts = this.flattenContracts(contracts)
		const contractIndex = allContracts.findIndex(({ contractId }) => contractId === openedId)
		return allContracts[contractIndex] || null
	}

	flattenContracts(contracts) {
		return Object.values(contracts).flat()
	}

	update() {
		const { opened, dispatch } = this.props
		if (opened) {
			dispatch(fetchContractData(opened))
		}
	}

	render() {
		const { filter, opened, contracts, onBackClicked, onLinkClicked, isPhone, isTablet } = this.props
		const allContracts = this.flattenContracts(contracts)
		const filteredContracts = filter ? [...contracts[filter]] : allContracts
		const openedContract = opened ? this.returnOpenedContract(opened) : null

		return (
			get(openedContract, 'contractDetails') ? (
				<ContractDetails
					contract={openedContract}
					onBackClicked={onBackClicked}
					isPhone={isPhone}
					isTablet={isTablet}
				/>
			) : (
				<div className={styles.wrapper}>
					<EasinsureContractsFilter
						filter={filter}
						contracts={contracts}
						onFilter={this.handleFilterClicked}
					/>
					<EasinsureContractsList
						filter={filter}
						filteredContracts={filteredContracts}
						onLinkClicked={onLinkClicked}
						isPhone={isPhone}
					/>
				</div>
			)
		)
	}
}
EasinsureContracts.propTypes = {
	contracts: PropTypes.object,
	opened: PropTypes.string,
	filter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onBackClicked: PropTypes.func,
	onLinkClicked: PropTypes.func,
	className: PropTypes.string,
	isPhone: PropTypes.bool,
	isTablet: PropTypes.bool,
	dispatch: PropTypes.func, // from connect
}



// WEBPACK FOOTER //
// ./components/easinsure/contracts/EasinsureContracts.jsx